import {
    GET_CONFIG_FORM27,    
    GET_DATOS_ANTECEDENTES,
    GET_DATOS_GRILLA
} from '../types';

export default function AntecedentesJudicialesReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM27:
            return { ...state, cfg_form27:action.payload }
        case GET_DATOS_ANTECEDENTES:
            return { ...state, datosAntecedentes:action.payload }
        case GET_DATOS_GRILLA:
            return { ...state, datosGrilla:action.payload }
       
       
       
        default:
            return state
    }
}